module.exports = __webpack_public_path__ + "img/coin.2c21a41e.png";